/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProductLists_ProductListFragmentDoc } from '../../main-routes/products/ProductLists.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateProductListMutationVariables = Types.Exact<{
  input: Types.UpdateProductListInput;
}>;


export type UpdateProductListMutation = { updateProductList: { __typename: 'UpdateProductListResult', productList: { __typename: 'ProductList', id: string, title: string, description: string, createdAt: any, itemCount: number, author: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string } } } };


export const UpdateProductListDocument = gql`
    mutation UpdateProductList($input: UpdateProductListInput!) {
  updateProductList(input: $input) {
    productList {
      ...ProductLists_ProductList
    }
  }
}
    ${ProductLists_ProductListFragmentDoc}`;
export type UpdateProductListMutationFn = Apollo.MutationFunction<UpdateProductListMutation, UpdateProductListMutationVariables>;

/**
 * __useUpdateProductListMutation__
 *
 * To run a mutation, you first call `useUpdateProductListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductListMutation, { data, loading, error }] = useUpdateProductListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductListMutation, UpdateProductListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductListMutation, UpdateProductListMutationVariables>(UpdateProductListDocument, options);
      }
export type UpdateProductListMutationHookResult = ReturnType<typeof useUpdateProductListMutation>;
export type UpdateProductListMutationResult = Apollo.MutationResult<UpdateProductListMutation>;
export type UpdateProductListMutationOptions = Apollo.BaseMutationOptions<UpdateProductListMutation, UpdateProductListMutationVariables>;